import { all, spawn } from 'redux-saga/effects';
import backpackSagas from './sagas';

export default function* root() {
    yield all([spawn(backpackSagas)]);
}
